import { useEffect, useState } from 'react'
import { useQuill } from 'react-quilljs'

interface RichTextEditorProps {
  title?: string
  value?: string
  onChange: (value: string) => void
  className?: string
  height?: number
}

export const RichTextEditor = ({
  title,
  value = '',
  onChange = () => {},
  className = '',
  height,
}: RichTextEditorProps) => {
  const [isInitialized, setIsInitialized] = useState(false)

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'code-block'],
      ['link', 'image', 'video'],
      [{ indent: '-1' }, { indent: '+1' }],
      ['clean'],
    ],
    clipboard: {
      matchVisual: false,
    },
  }

  const formats = [
    'bold',
    'italic',
    'underline',
    'strike',
    'header',
    'font',
    'color',
    'background',
    'align',
    'list',
    'indent',
    'blockquote',
    'code-block',
    'link',
    'image',
    'video',
  ]

  const { quill, quillRef } = useQuill({ modules, formats })

  // Initialize the editor with content
  useEffect(() => {
    if (quill && value && !isInitialized) {
      // Wait for Quill to be fully initialized
      setTimeout(() => {
        quill.setContents([])
        quill.clipboard.dangerouslyPasteHTML(0, value)
        setIsInitialized(true)
      }, 100)
    }
  }, [quill, value, isInitialized])

  // Track changes in the editor
  useEffect(() => {
    if (quill) {
      quill.on('text-change', () => {
        const html = quill.root.innerHTML
        onChange(html)
      })
    }
  }, [quill, onChange])

  return (
    <div className={`rich-text-editor ${className}`}>
      {title && <p className="text-sm mb-2">{title}</p>}
      <div className={`w-full rounded overflow-hidden`} style={{ height: `${height || 250}px` }}>
        <div ref={quillRef} className="h-full" />
      </div>
    </div>
  )
}
